import { Add, Calculate } from '@mui/icons-material'
import { Menu, MenuItem, Stack } from '@mui/material'
import { getProgramsByCompanyId } from '@src/data/types/FinancingCompanies'
import { MouseEvent, useMemo, useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import IconButtonWithTooltip from '../../components/IconButtonWithTooltip'
import { useAppSelector } from '../../data/store'
import { userSelectors } from '../../data/store/UserStore'

const MainActions = (): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const selectedCompany = useAppSelector(userSelectors.selectedCompany)
  const user = useAppSelector(userSelectors.getUser)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const availableFinancingProgramMenuItems = useMemo(
    () =>
      getProgramsByCompanyId([selectedCompany!]).map((item) => (
        <MenuItem key={item} onClick={() => navigate(`/Applications/${item}/add`)}>
          {t(`EFinancingProgram.${item}`, { ns: 'enum' })}
        </MenuItem>
      )),
    [navigate, selectedCompany, t],
  )

  return (
    <Stack direction="row">
      <IconButtonWithTooltip
        tooltip={t('browseCreditApplications.mainActions.newApplication')}
        icon={<Add color="primary" />}
        onClick={handleClick}
        disabled={!user?.rights.canEditCreditApp}
      />
      <IconButtonWithTooltip
        tooltip={t('browseCreditApplications.mainActions.calculate')}
        icon={<Calculate color="primary" />}
        onClick={() => undefined}
      />
      <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose}>
        {availableFinancingProgramMenuItems}
      </Menu>
    </Stack>
  )
}

export default MainActions
